"use strict";

exports.__esModule = true;
exports.utils = exports.isRTL = exports.setConfig = exports.Upload = exports.TreeSelect = exports.Tree = exports.Transfer = exports.Tooltip = exports.Textarea = exports.Tag = exports.Tabs = exports.Table = exports.Switch = exports.Sticky = exports.Spin = exports.Slider = exports.Select = exports.Scroll = exports.Rule = exports.Rate = exports.Radio = exports.Progress = exports.Popover = exports.Pagination = exports.Modal = exports.Message = exports.Menu = exports.Lazyload = exports.Input = exports.Image = exports.Icon = exports.Grid = exports.Gap = exports.Form = exports.EditableArea = exports.Dropdown = exports.Divider = exports.Datum = exports.DatePicker = exports.Checkbox = exports.Cascader = exports.Carousel = exports.CardGroup = exports.Card = exports.Button = exports.Breadcrumb = exports.AnimationList = exports.Alert = exports.List = exports.LazyList = exports.config = exports.style = exports.color = exports.setLocale = exports.default = void 0;

require("./styles/normalize.less");

var utils = _interopRequireWildcard(require("./utils"));

exports.utils = utils;

var _locale = require("./locale");

exports.setLocale = _locale.setLocale;

var _expose = require("./utils/expose");

exports.color = _expose.color;
exports.style = _expose.style;

var _config = _interopRequireWildcard(require("./config"));

exports.config = _config.default;
exports.setConfig = _config.setConfig;
exports.isRTL = _config.isRTL;

var _LazyList = _interopRequireDefault(require("./AnimationList/LazyList"));

exports.LazyList = _LazyList.default;

var _DataList = _interopRequireDefault(require("./DataList"));

exports.List = _DataList.default;

var _Alert = _interopRequireDefault(require("./Alert"));

exports.Alert = _Alert.default;

var _AnimationList = _interopRequireDefault(require("./AnimationList"));

exports.AnimationList = _AnimationList.default;

var _Breadcrumb = _interopRequireDefault(require("./Breadcrumb"));

exports.Breadcrumb = _Breadcrumb.default;

var _Button = _interopRequireDefault(require("./Button"));

exports.Button = _Button.default;

var _Card = _interopRequireDefault(require("./Card"));

exports.Card = _Card.default;

var _CardGroup = _interopRequireDefault(require("./CardGroup"));

exports.CardGroup = _CardGroup.default;

var _Carousel = _interopRequireDefault(require("./Carousel"));

exports.Carousel = _Carousel.default;

var _Cascader = _interopRequireDefault(require("./Cascader"));

exports.Cascader = _Cascader.default;

var _Checkbox = _interopRequireDefault(require("./Checkbox"));

exports.Checkbox = _Checkbox.default;

var _DatePicker = _interopRequireDefault(require("./DatePicker"));

exports.DatePicker = _DatePicker.default;

var _Datum = _interopRequireDefault(require("./Datum"));

exports.Datum = _Datum.default;

var _Divider = _interopRequireDefault(require("./Divider"));

exports.Divider = _Divider.default;

var _Dropdown = _interopRequireDefault(require("./Dropdown"));

exports.Dropdown = _Dropdown.default;

var _EditableArea = _interopRequireDefault(require("./EditableArea"));

exports.EditableArea = _EditableArea.default;

var _Form = _interopRequireDefault(require("./Form"));

exports.Form = _Form.default;

var _Gap = _interopRequireDefault(require("./Gap"));

exports.Gap = _Gap.default;

var _Grid = _interopRequireDefault(require("./Grid"));

exports.Grid = _Grid.default;

var _Icon = _interopRequireDefault(require("./Icon"));

exports.Icon = _Icon.default;

var _Image = _interopRequireDefault(require("./Image"));

exports.Image = _Image.default;

var _Input = _interopRequireDefault(require("./Input"));

exports.Input = _Input.default;

var _Lazyload = _interopRequireDefault(require("./Lazyload"));

exports.Lazyload = _Lazyload.default;

var _Menu = _interopRequireDefault(require("./Menu"));

exports.Menu = _Menu.default;

var _Message = _interopRequireDefault(require("./Message"));

exports.Message = _Message.default;

var _Modal = _interopRequireDefault(require("./Modal"));

exports.Modal = _Modal.default;

var _Pagination = _interopRequireDefault(require("./Pagination"));

exports.Pagination = _Pagination.default;

var _Popover = _interopRequireDefault(require("./Popover"));

exports.Popover = _Popover.default;

var _Progress = _interopRequireDefault(require("./Progress"));

exports.Progress = _Progress.default;

var _Radio = _interopRequireDefault(require("./Radio"));

exports.Radio = _Radio.default;

var _Rate = _interopRequireDefault(require("./Rate"));

exports.Rate = _Rate.default;

var _Rule = _interopRequireDefault(require("./Rule"));

exports.Rule = _Rule.default;

var _Scroll = _interopRequireDefault(require("./Scroll"));

exports.Scroll = _Scroll.default;

var _Select = _interopRequireDefault(require("./Select"));

exports.Select = _Select.default;

var _Slider = _interopRequireDefault(require("./Slider"));

exports.Slider = _Slider.default;

var _Spin = _interopRequireDefault(require("./Spin"));

exports.Spin = _Spin.default;

var _Sticky = _interopRequireDefault(require("./Sticky"));

exports.Sticky = _Sticky.default;

var _Switch = _interopRequireDefault(require("./Switch"));

exports.Switch = _Switch.default;

var _Table = _interopRequireDefault(require("./Table"));

exports.Table = _Table.default;

var _Tabs = _interopRequireDefault(require("./Tabs"));

exports.Tabs = _Tabs.default;

var _Tag = _interopRequireDefault(require("./Tag"));

exports.Tag = _Tag.default;

var _Textarea = _interopRequireDefault(require("./Textarea"));

exports.Textarea = _Textarea.default;

var _Tooltip = _interopRequireDefault(require("./Tooltip"));

exports.Tooltip = _Tooltip.default;

var _Transfer = _interopRequireDefault(require("./Transfer"));

exports.Transfer = _Transfer.default;

var _Tree = _interopRequireDefault(require("./Tree"));

exports.Tree = _Tree.default;

var _TreeSelect = _interopRequireDefault(require("./TreeSelect"));

exports.TreeSelect = _TreeSelect.default;

var _Upload = _interopRequireDefault(require("./Upload"));

exports.Upload = _Upload.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

// Created by scripts/src-index.js.
var _default = {
  utils: utils,
  version: '1.6.5'
};
exports.default = _default;